import { useAlert } from '@genial/components';
import { Service } from '@genial/services';
import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { v4 } from 'uuid';

import { useToastCreator } from '../../hooks/useToastCreator';
import { advisorIdToApisSelector } from '../master/selector';

import { TransactionFlowExcelResponse } from './types';

export const useTransactionFlowActions = () => {
  const advisorSelected = useRecoilValue(advisorIdToApisSelector);

  const { alert, remove: removeAlert } = useAlert();
  const { showToast } = useToastCreator(v4());

  const downloadTransactionFlowHistory = useCallback(
    async (initialDate: Date, endDate: Date, productType: number) => {
      const displayError = () => {
        showToast(
          'error',
          'Não foi possível baixar o relatório.',
          'Não foi possível baixar o relatório. Ocorreu um erro ao tentar baixar o relatório. Por favor, tente novamente mais tarde ou entre em contato com time de middle pelo e-mail middleb2b@genial.com.vc.'
        );
      };

      alert({
        title: 'Aviso',
        description:
          'Esta solicitação pode levar alguns segundos. Assim que o download for  \n' +
          'finalizado, o arquivo será baixado automaticamente.',
        icon: 'BackInTime',
        iconSize: 'xl',
        actionText: 'CONTINUAR',
      });

      const filtersRequest = {
        screenName: 'transaction-flow-historical-search',
        filtroMovimentacoes: {
          dataMovimentoInicio: initialDate,
          dataMovimentoFim: endDate,
          idAssessor: advisorSelected,
          tipoProduto: productType,
        },
      };

      try {
        const response =
          (await Service.External.Extranet.Movimentacao.V1.movimentacaoObterExcelHistoricoMovimentacoesClientes(
            filtersRequest
          )) as TransactionFlowExcelResponse;

        if (!response || !response?.base64 || !response.fileName) {
          displayError();
          return;
        }

        const byteCharacters = atob(response.base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = response.fileName || 'movimentacoes.xlsx';
        a.click();
      } catch (_e) {
        console.log('_error', _e);

        displayError();
      } finally {
        removeAlert();
      }
    },
    [advisorSelected, alert, advisorSelected]
  );

  return {
    downloadTransactionFlowHistory,
  };
};
